import { createFileRoute } from "@tanstack/react-router";
import { BooksPage } from "../features/books/BooksPage";

export const Route = createFileRoute("/w/$ws/books")({ component: BooksPage });
